import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../base/Image/Image';

const CarouselItem = ({active, className, img}) => {
   
    const carouselItemClassValue = classNames(
        "item",
        {"active": active},
        className
    );
    
    return(
        <div className={carouselItemClassValue}>
            <Image additionalClass={className}
            imageSrc={img} />
        </div>
    );
};

CarouselItem.propTypes = {
    className: PropTypes.string   
};

export default CarouselItem;


// WEBPACK FOOTER //
// ./src/components/Carousel/CarouselItem.js